import React from 'react';
import { Activity } from 'lucide-react';
import type { GlassBoxItem } from '../../../hooks/useGlassBoxEvents';

interface Props {
  item: GlassBoxItem;
}

export function GenericObsEvent({ item }: Props) {
  return (
    <div className="flex items-center gap-2 py-1.5 px-3 hover:bg-surface-800/40 rounded group">
      <Activity className="w-3.5 h-3.5 flex-shrink-0 text-text-muted" />
      <span className="text-xs text-text-secondary font-mono truncate flex-1">{item.event}</span>
      <div className="flex-shrink-0 text-[10px] text-text-muted opacity-0 group-hover:opacity-100 transition-opacity">
        {new Date(item.receivedAt).toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })}
      </div>
    </div>
  );
}
